import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ServiceAmountsFees } from '../serviceamountsfees.model';
import { ServicesamountsfeesService } from '../servicesamountsfees.service';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-servicesamountsfeesform',
  templateUrl: './servicesamountsfeesform.component.html',
  styleUrls: ['./servicesamountsfeesform.component.css']
})
export class ServicesamountsfeesformComponent implements OnInit {

  ServiceAmountsFeesForm!: FormGroup

  serviceAmountsFeesList: ServiceAmountsFees[] = [];
  spinnerOverlay = false;
  constructor(
    private service: ServicesamountsfeesService,
    private translateService: TranslateService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.connectFormGroup()
    this.get()
  }

  connectFormGroup() {

    let _serviceAmountFees = new FormArray([]);

    this.ServiceAmountsFeesForm = new FormGroup({
      serviceAmountsFees: _serviceAmountFees!,
    });

    this.addServiceAmountsFeesRow();
  }

  getServiceAmountsFeesControls() {
    return (<FormArray>this.ServiceAmountsFeesForm.get('serviceAmountsFees')).controls;
  }

  addServiceAmountsFeesRow() {
    (<FormArray>this.ServiceAmountsFeesForm.get('serviceAmountsFees')).push(
      new FormGroup({
        id: new FormControl(""),
        fromAmount: new FormControl('', Validators.required),
        toAmount: new FormControl('', Validators.required),
        fees: new FormControl('', Validators.required)
      }))
  }

  deleteRow(index: number) {

    const control = (<FormArray>this.ServiceAmountsFeesForm.get('serviceAmountsFees'));
    if (control.length != 1)
      control.removeAt(index);
  }

  get() {
    this.spinnerOverlay = true;
    this.serviceAmountsFeesList = [];

    this.service.getAll().subscribe(data => {
      this.serviceAmountsFeesList = data;
      this.fillControl();
      this.spinnerOverlay = false
    }, error => {
      console.log(error)
      this.spinnerOverlay = false;
    })
  }


  fillControl() {

    if (this.serviceAmountsFeesList.length > 0) {
      (<FormArray>this.ServiceAmountsFeesForm.get('serviceAmountsFees')).removeAt(0);
    }
    for (let i = 0; i < this.serviceAmountsFeesList.length; i++) {

      (<FormArray>this.ServiceAmountsFeesForm.get('serviceAmountsFees')).push(
        new FormGroup({
          id: new FormControl(this.serviceAmountsFeesList[i].id),
          fromAmount: new FormControl(this.serviceAmountsFeesList[i].fromAmount),
          toAmount: new FormControl(this.serviceAmountsFeesList[i].toAmount),
          fees: new FormControl(this.serviceAmountsFeesList[i].fees)
        }));
    }

  }

  submit() {
    this.create();
  }

  create() {
    this.spinnerOverlay = true;
    var serviceFeesAmount = this.ServiceAmountsFeesForm.value.serviceAmountsFees;
    var listServiceAmountFees = [];

    for (let i = 0; i < serviceFeesAmount.length; i++) {
      var obj = {
        id: serviceFeesAmount[i].id != "" && serviceFeesAmount[i].id != null ?
          serviceFeesAmount[i].id : 0,
        fromAmount: serviceFeesAmount[i].fromAmount,
        toAmount: serviceFeesAmount[i].toAmount,
        fees: serviceFeesAmount[i].fees,
      }
      listServiceAmountFees.push(obj)

    }

    this.service.CreateUpdate(listServiceAmountFees).subscribe(data => {
      this.openSnackBar(this.translateService.instant("createdSuccessfully"), 'snackBarSuccess');
      // this.get();
      this.spinnerOverlay = false
    },
      error => {
        console.log(error);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }

        this.spinnerOverlay = false;
      })
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

}
